export default __webpack_public_path__ + "assets/sounds/6558c0b03f349505b6c8531a63c4b740.mp3";